module.exports = __webpack_public_path__ + "static/images/monet/tree_folder_closed.svg";